export default __webpack_public_path__ + "static/media/arrow.765907c8.svg";